const config = {
  baseUrl: `https://gold-api.agrostar.in`,
  meetingBaseUrl: `https://gold-join.agrostar.in`,
  appUrl: `https://gold.agrostar.in`,
  locationServiceUrl: `https://communication.agrostar.in/appuserservice/v1/maxmindlocation`,
  otpServiceUrl: `https://crm.agrostar.in/userservice/otp/`,
  gcpBucketBase: `https://static.agrostar.in/agro-elearning-firebase/v0/b/agro-elearning/o/`,
  razerpayKeyId: `rzp_live_bvpmTOPnA2FJau`,
  leadServiceUrl: `https://dialerservice.agrostar.in/dialerservice/registerAppCall/`,
  crmServiceUrl: `https://crm.agrostar.in/crmservice/v1/`,
  genieLeadManagementUrl: `https://crm.agrostar.in/leadmanagementservice/v1/`,
  crmXAuthToken: `05302c15-2068-461c-9306-fde494ca1a7e`,
  unifydBaseUrl: `https://gold-join.agrostar.in/`,
  agronomyService: `https://communication.agrostar.in`,
};

export default config;
